import React from 'react';

import { layout } from '../../modules';
import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';

import './CardFooter.less';

const block = bemBlock('n-card-footer');

export type CardFooterProps = {
  className?: string;
  children?: React.ReactNode;
  nextSlot?: React.ReactNode;
  span?: layout.Span;
};

export const CardFooter: React.FC<CardFooterProps> = ({ className, children, nextSlot, span }) => {
  return (
    <Layout.Row
      className={block({ extra: className })}
      withPadding={['md', 'lg']}
      justifyContent="space-between"
      reversed={!!nextSlot}
      spacedChildren="md"
      span={span}
    >
      {nextSlot && <Layout.Element>{nextSlot}</Layout.Element>}
      <Layout.Row spacedChildren="md" span="greedy">
        {children}
      </Layout.Row>
    </Layout.Row>
  );
};
